import { Directive, ElementRef, Input, OnChanges, Renderer2 } from '@angular/core';

@Directive({
  selector: '[appCountUp]'
})
export class CountUpDirective implements OnChanges {
  @Input('appCountUp') endValue = 0;
  @Input() duration = 1000; // ms

  private currentVal = 0;
  private startTime: number | null = null;

  constructor(private el: ElementRef, private renderer: Renderer2) {}

  ngOnChanges(): void {
    this.animate();
  }

  private animate() {
    const startVal = this.currentVal;
    const change = this.endValue - startVal;

    const step = (timestamp: number) => {
      if (!this.startTime) this.startTime = timestamp;
      const progress = timestamp - this.startTime;
      const percent = Math.min(progress / this.duration, 1);
      const current = startVal + change * percent;

      this.renderer.setProperty(this.el.nativeElement, 'textContent', Math.round(current).toLocaleString());

      if (progress < this.duration) {
        requestAnimationFrame(step);
      } else {
        this.renderer.setProperty(this.el.nativeElement, 'textContent', this.endValue.toLocaleString());
        this.currentVal = this.endValue;
        this.startTime = null;
      }
    };

    requestAnimationFrame(step);
  }
}
